// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"180":"c0303f92","432":"e8cb0f8f","711":"5919c7bb","911":"0206996a"}[chunkId] + ".chunk.css";
};